import { useEffect, useState } from "react";
import "./About.css";

const SWIPER_IMAGES = [
    { src: "/img/img_01.jpg", alt: "Activación UHUB 1" },
    { src: "/img/img_02.jpg", alt: "Activación UHUB 2" },
    { src: "/img/img_03.jpg", alt: "Activación UHUB 3" },
    { src: "/img/img_04.jpg", alt: "Activación UHUB 4" },
    { src: "/img/img_05.jpg", alt: "Activación UHUB 5" },
    { src: "/img/img_06.jpg", alt: "Activación UHUB 6" },
];

export default function About({
    id = "about",
    imageAlt = "Estudiantes probando realidad virtual en un evento de UniversityHub",
    title = "¿QUIÉNES SOMOS?",
    headline = "Somos un ecosistema que une marcas, universidades y estudiantes a través de activaciones enfocadas en educación y entretenimiento. ",
    subheadline = `Buscamos fomentar el crecimiento de la tecnología, del gaming y los esports en la región fortaleciendo las relaciones con el ámbito educativo.`,
    ctaHref = "#footer",
    stats = [
        { value: "20+", label: "Universidades que ya vivieron la experiencia UHUB. 3 años de trayectoria." },
        { value: "250k", label: "Estudiantes conectados en el ecosistema a través de activaciones de gaming, y educación." },
        { value: "87", label: "Es el resultado de NPS de los estudiantes por sobre las activaciones realizadas. Respaldados por nuestra comunidad." },
    ],
}) {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrent(i => (i + 1) % SWIPER_IMAGES.length);
        }, 3500);
        return () => clearInterval(timer);
    }, []);

    return (
        <section id={id} className="about">
            <div className="about-inner">
                <div className="about-grid">
                    <div className="about-media">
                        <div className="about-swiper">
                            {SWIPER_IMAGES.map((img, i) => (
                                <img
                                    key={img.src}
                                    src={img.src}
                                    alt={img.alt}
                                    className={`about-swiper-img${i === current ? " is-active" : ""}`}
                                    loading="lazy"
                                />
                            ))}
                            <div className="about-swiper-dots">
                                {SWIPER_IMAGES.map((_, i) => (
                                    <button
                                        key={i}
                                        className={`about-dot${i === current ? " is-active" : ""}`}
                                        onClick={() => setCurrent(i)}
                                        aria-label={`Imagen ${i + 1}`}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="about-copy">
                        <h1 className="about-title">{title}</h1>
                        <h2 className="about-headline">{headline}</h2>
                        <h3 className="about-subheadline">{subheadline}</h3>

                        <div className="about-cta">
                            <a
                                href="https://www.instagram.com/uhublatam/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="about-btn about-btn-primary"
                            >Novedades</a>
                            <a
                                href="https://docsend.com/view/wkfnhghjx23fygj9"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="about-btn about-btn-secondary"
                            >Saber más</a>
                        </div>
                    </div>
                </div>

                <ul className="about-stats">
                    {stats.map((s, i) => (
                        <li className="stat" key={i}>
                            <div className="stat-value">{s.value}</div>
                            <div className="stat-label">
                                {s.label.split("\n").map((line, idx) => (
                                    <span key={idx} className="line">{line}{idx !== s.label.split("\n").length - 1 && <br />}</span>
                                ))}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}
